import React from "react";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";

import Grid from "@mui/material/Grid";

import useMediaQuery from "@mui/material/useMediaQuery";
import config from "../config";

const useStyles = makeStyles((theme) => ({
  sectionTitleMobile: {
    fontWeight: "bold",
    // marginLeft: "1rem",
    marginLeft: theme.spacing(1.5),
    fontSize: "18px",
    alignItems: "center",
  },
  sectionTitleDesktop: {
    fontWeight: "bold",
    marginLeft: theme.spacing(-4),
  },
  sectionTitleNoMargin: {
    marginLeft: 0,
  },
  sectionTitleIcon: {
    height: theme.spacing(3.25),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(-1),
  },
  sectionTitleIconWide: {
    height: theme.spacing(3),
    marginRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(-1),
  },
}));

export default function SectionTitle(props) {
  const theme = useTheme();
  let isSmallDevice = useMediaQuery(theme.breakpoints.down('lg'));
  const classes = useStyles();

  return <>
    {props?.title && (
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <Typography
            variant={"h6"}
            component={"h6"}
            align={"left"}
            className={
              isSmallDevice
                ? classes.sectionTitleMobile
                : classes.sectionTitleDesktop
            }
          >
            <img
              className={
                props.wideIcon
                  ? classes.sectionTitleIconWide
                  : classes.sectionTitleIcon
              }
              src={`${config.appUrl}/${props.icon}`}
              alt=""
            />
            {props.title}
          </Typography>
        </Grid>
      </Grid>
    )}
  </>;
}
